import { css } from 'lit';

export const sharedStyles = css`
    :host {
        font-family: 'Blue Ridge Sans', Arial, sans-serif;
        color: var(--neutral-800, #222425);
    }
    /* serif font */
    @font-face {
        font-family: 'BlueRidge';
        src:
            url('https://litehouse.bcbsnc.com/assets/fonts/BlueRidgeVariable.woff2') format('woff2 supports variations'),
            url('https://litehouse.bcbsnc.com/assets/fonts/BlueRidgeVariable.woff2') format('woff2-variations');
        font-weight: 400 800;
        font-display: block;
    }
    /* sans-serif font */
    @font-face {
        font-family: 'BlueRidgeSans';
        src:
            url('https://litehouse.bcbsnc.com/assets/fonts/BlueRidgeSansVariable.woff2')
                format('woff2 supports variations'),
            url('https://litehouse.bcbsnc.com/assets/fonts/BlueRidgeSansVariable.woff2') format('woff2-variations');
        font-weight: 100 800;
        font-display: block;
    }

    .text-right {
        text-align: right;
    }
    .text-left {
        text-align: left;
    }
    .align-middle {
        vertical-align: middle !important;
    }
    .align-items-start {
        align-items: flex-start !important;
    }
    .align-items-end {
        align-items: flex-end !important;
    }
`;
